import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Home, ArrowLeft } from "lucide-react";
import SkalaLogo from "../components/SkalaLogo";
import { useLanguage } from "../contexts/LanguageContext";

export default function NotFoundPage() {
    const { language } = useLanguage();
    const copy = {
        en: { title: "Page not found", text: "The link is broken or the page has moved. Let's get you back on track.", home: "Back to home", back: "Go back" },
        pt: { title: "Página não encontrada", text: "O link está quebrado ou a página foi movida. Vamos te colocar de volta na rota.", home: "Voltar ao início", back: "Voltar" },
        es: { title: "Página no encontrada", text: "El enlace está roto o la página fue movida. Volvamos al camino correcto.", home: "Volver al inicio", back: "Regresar" },
        ru: { title: "Страница не найдена", text: "Ссылка повреждена или страница перенесена. Вернём вас в рабочий маршрут.", home: "На главную", back: "Назад" },
        tr: { title: "Sayfa bulunamadı", text: "Bağlantı bozuk olabilir veya sayfa taşınmış olabilir. Seni doğru sayfaya geri alalım.", home: "Ana sayfaya dön", back: "Geri dön" },
    };
    const c = copy[language] || copy.en;

    return (
        <div data-testid="not-found-page" className="min-h-screen bg-background grid-bg flex items-center justify-center px-6">
            <div className="absolute top-6 left-6">
                <Link to="/">
                    <SkalaLogo />
                </Link>
            </div>
            <div className="max-w-md text-center relative">
                <div className="font-display font-black text-[140px] md:text-[180px] leading-none tracking-tighter text-gradient-primary">
                    404
                </div>
                <h1 className="font-display font-bold text-2xl md:text-3xl tracking-tight mt-2">
                    {c.title}
                </h1>
                <p className="text-muted-foreground text-sm md:text-base mt-3 leading-relaxed max-w-sm mx-auto">
                    {c.text}
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mt-8">
                    <Link to="/" data-testid="404-home-link">
                        <Button className="bg-primary hover:bg-primary/90 text-primary-foreground font-semibold h-11 px-6">
                            <Home className="w-4 h-4 mr-2" /> {c.home}
                        </Button>
                    </Link>
                    <button
                        onClick={() => window.history.back()}
                        className="text-sm text-muted-foreground hover:text-foreground inline-flex items-center gap-1"
                    >
                        <ArrowLeft className="w-3.5 h-3.5" /> {c.back}
                    </button>
                </div>
            </div>
        </div>
    );
}
